<button
  type="button"
  class="filter-toggle-btn"
  [ngClass]="variant"
  (click)="onToggle()">

  <i class="bi bi-funnel"></i>
  <span>
    {{ showAdvanced ? 'Hide Filters' : 'Advanced Filters' }}
  </span>

</button>
